<template>
    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">Research Connect</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-details detail-section">
            <div class="container">
                <div class="row">

                    <div class="col-12">
                        <div class="details-content">
                            <div class="text">
                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>
                                        This is a Researchers Community and Social Network of Targeted 50,000
                                        Researchers, innovators and builders within Africa and in the Diaspora.
                                    </p>

                                    <p>
                                        The goal is to eventually grow this to a community of Over a Million Researchers
                                        actively Using the Platform and ensuring they have all they need.
                                    </p>

                                    <p>
                                        The Target Goals for ResearchConnect platform is to:
                                    </p>

                                    <ul class="list">
                                        <li>
                                            Expose Researchers to Resources (not just our own resources) as much as
                                            needed
                                        </li>
                                        <li>
                                            enable virtual cross Continental Collaborations for:
                                            <ul class="list">
                                                <li>Collaborative Research </li>
                                                <li>Co-Creation </li>
                                                <li>Co-Contribution to Papers</li>
                                                <li>and more...</li>
                                            </ul>
                                        </li>
                                        <li>
                                            make communications and collaboration rooms available in open Mode or closed
                                            and security Modes
                                        </li>
                                        <li>
                                            Enable Knowledge Sharing, Technology Transfer and Innovations evaluation for
                                            Global Adoptability
                                        </li>
                                        <li>
                                            Ideas Sharing and Brainstorming on problems
                                        </li>
                                        <li>
                                            Research Idea Pitching for:
                                            <ul class="list">
                                                <li>Funding</li>
                                                <li>Equipment</li>
                                                <li>Co-researchers</li>
                                                <li>and more...</li>
                                            </ul>
                                        </li>
                                        <li>
                                            Getting Discounted Access via Exclusive or Premium Membership to our Partner
                                            Brands and Solutions such as;
                                            <ul class="list">
                                                <li>Tribinnov CO-OP</li>
                                                <li>Tribinnov Capital</li>
                                            </ul>
                                        </li>
                                        <li>
                                            Our Custom Tool to Validate Research Work
                                            <ul class="list">
                                                <li> Researcher Valiidator Tool</li>
                                                <li>and more...</li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <div class="button my-5" style="text-align: center;">
                                        <a href="https://app.tribinnovafrica.com/register?type=research" target="_blank"
                                            class="btn">Join The Research Community <i
                                                class="lni lni-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ResearcherConnect',
        metaInfo: {
            title: "Tribinnov Africa - Research Connect",
            meta: [
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>